import { render, staticRenderFns } from "./leaveSettingPop.vue?vue&type=template&id=35699108&scoped=true&"
import script from "./leaveSettingPop.vue?vue&type=script&lang=js&"
export * from "./leaveSettingPop.vue?vue&type=script&lang=js&"
import style0 from "./leaveSettingPop.vue?vue&type=style&index=0&id=35699108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35699108",
  null
  
)

export default component.exports